<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon">close</mat-icon>
</button>
<div *ngIf="!loaded" class="image-loading-icon">
  <img [src]="'/assets/images/animated-spinner.svg'"><br>Loading
</div>
<div *ngIf="image$ | async as image" class="image-container">
  <img class="image-container__image" [src]="image | safe:'url'" [alt]="name" sharedClickOutsideDirective (clickOutside)="close()" (load)="loaded = true">
</div>
